import { useEffect, useRef, useState } from "react";
import { AuthorNameHelper } from "../../helper/AuthorNameHelper";
import { Link } from "react-router-dom";
import { sanitizeHTML } from "../../helper/SanitizeHTML";
const Descriptions = ({ bookDetail, socialIcon }) => {
  useEffect(() => {
    if (!document.getElementById("social-sharing-script")) {
      var ssScript = document.createElement("script");
      var inlineScript = document.createTextNode(
        'function theChampPopup(e) {window.open(e,"_blank","height=420,width=620,left=390,top=105,resizable,scrollbars,toolbar=0,personalbar=0,menubar=no,location=no,directories=no,status");}'
      );
      ssScript.appendChild(inlineScript);
      ssScript.id = "social-sharing-script";
      document.head.appendChild(ssScript);
    }
  }, []);
  const book_description = useRef();
  const [desc, setDesc] = useState(book_description);
  const [show, setShow] = useState(false);
  const {
    title,
    subtitle: sub_title,
    img_path,
    book_edition,
    author_details,
    editor_details,
    translated_by,
    description,
  } = bookDetail;
  const handleShowHide = () => {
    setShow(!show);
  };

  const fullTitle =
    sub_title === "" && book_edition !== "1" && !title.includes(book_edition)
      ? title + ", " + book_edition
      : title;

  return (
    <div className="row">
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 subject_intro_text">
        <div className="row book_detail_page">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 book_blog_page">
            <div
              className="col-xs-12 col-sm-4 col-md-3 col-lg-3"
              style={{ border: "solid red 0px" }}
            >
              <div className="books_images">
                {img_path ? (
                  <img
                    src={img_path}
                    data-pin-nopin="true"
                    alt={title}
                    title={`${title}${sub_title}`}
                    className="book_cover_image lazy"
                  />
                ) : (
                  <div className="book_no_image">No Image</div>
                )}
              </div>

              <div
                style={{
                  float: "left",
                  width: "100%",
                  paddingTop: "20px",
                  textAlign: "center",
                  border: "solid red 0px",
                }}
                className="social_icons_center"
              >
                {socialIcon && (
                  <span dangerouslySetInnerHTML={{ __html: socialIcon }}></span>
                )}
              </div>
            </div>
            <div
              className="col-xs-12 col-sm-8 col-md-9 col-lg-9"
              style={{ border: "solid green 0px" }}
            >
              <div className="books_description">
                {/* WEB-331 - fixing the title issue using dangerouslySetInnerHTML  */}
                <h1
                  className="american_century_heading pull-left"
                  dangerouslySetInnerHTML={sanitizeHTML(fullTitle)}
                />

                <div
                  className="american_century_heading pull-left"
                  style={{ fontSize: "25pt", clear: "both" }}
                >
                  {book_edition !== "1" && sub_title !== ""
                    ? sub_title + ", " + book_edition
                    : sub_title}
                </div>
                <div className="author_name pull-left">
                  {AuthorNameHelper(author_details)}
                </div>
                {editor_details.length > 0 && (
                  <div className="tag_line_author pull-left">
                    Edited by{" "}
                    {editor_details.map((e, i) => (
                      <Link to={`/author-books?author_slug=${e.slug}`} key={i}>
                        {e.editor}
                        {i < editor_details.length - 1 ? ", " : ""}
                      </Link>
                    ))}
                  </div>
                )}
                {translated_by && (
                  <div className="tag_line_author pull-left">
                    {`Translated by ${translated_by}`}
                  </div>
                )}
                {description && (
                  <>
                    <div
                      className={`show_more_text pull-left ${
                        !show && "show_hide_description"
                      }`}
                      style={{ overflow: "hidden" }}
                    >
                      <p ref={(el) => setDesc(el)} id="book_description">
                        {description && (
                          <span
                            dangerouslySetInnerHTML={sanitizeHTML(description)}
                          />
                        )}
                      </p>
                      {!show && desc.offsetHeight > 220 && (
                        <div className="fadeBook"></div>
                      )}
                    </div>
                    {desc.offsetHeight > 220 && (
                      <span
                        rel={0}
                        style={{ cursor: "pointer" }}
                        className="showmoretxt pull-left"
                        onClick={handleShowHide}
                      >
                        {!show ? "Show More" : "Less"}
                      </span>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Descriptions;
